/**
 * 로딩
 */

import { create } from "zustand";

interface SetIsLoading {
  isLoading: boolean;
  showLoading: () => void;
  hideLoading: () => void;
}

const useIsLoadingStore = create<SetIsLoading>((set) => ({
  isLoading: false,

  showLoading: () => {
    set((state) => ({ isLoading: true }));
  },
  hideLoading: () => {
    set((state) => ({ isLoading: false }));
  },
}));

export default useIsLoadingStore;
